module.exports = __webpack_public_path__ + "static/media/APP_OfficeChamp_152x174_1.1cdfc3b7.png";